import {
  LocationFragment,
  LocationsQuery,
  SiteManagementLocationFragment,
  SiteManagementLocationsQuery,
} from '@occc/graphql';

export const transformDataToLocationsArray = (data: LocationsQuery): LocationFragment[] => {
  const edges = data.locations?.edges || [];

  return edges.map((item) => item.node);
};

export const transformDataToSiteManagementLocationsArray = (
  data: SiteManagementLocationsQuery,
): SiteManagementLocationFragment[] => {
  const edges = data.locations?.edges || [];

  return edges.map((item) => item.node);
};
